import React, { useCallback, useEffect, useMemo, useState } from "react";
import {
    Box,
    Button,
    Drawer,
    List,
    ListItem,
    ListItemButton,
    ListItemText,
    Typography,
    Divider,
    TextField,
    MenuItem,
    Alert,
    Stack,
    Paper,
    Container,
} from "@mui/material";


import { useCookies } from "react-cookie";
import useWebSocket from "react-use-websocket";
import axios from "axios";
import { Javascript } from "@mui/icons-material";

const socketUrl = "wss://brmm0q8jaa.execute-api.eu-central-1.amazonaws.com/production";

const KASSE_ENDPOINT = 'https://fkcrenezvf.execute-api.eu-central-1.amazonaws.com/Prod';


export default function CashRegisterSettings() {
    const [cookies] = useCookies(["secret", "station", "staff", "crKey"]);
    const [selectedItem, setSelectedItem] = useState(null);
    const [fiskalyClients, setFiskalyClients] = useState([]);
    const [clients, setClients] = useState([]);
    const [zvtTerminals, setZvtTerminals] = useState([]);
    const [error, setError] = useState(null);
    const [saveStatus, setSaveStatus] = useState("idle");



    const authHeaders = {
        headers: {
            Authorization: `Bearer ${cookies.crKey} y 1 z`,
        },
    };


    const { sendMessage, lastMessage } = useWebSocket(socketUrl, {
        queryParams: {
            station: cookies.station,
            secret: cookies.secret,
            staff: cookies.staff,
        },
        shouldReconnect: () => true,
    });

    useEffect(() => {
        sendMessage(JSON.stringify({
            task: "loadCashRegisterConfig",
            station: cookies.station,
            staff: cookies.staff
        }));
    }, [sendMessage]);

    useEffect(() => {
        if (!lastMessage) return;
        const msg = JSON.parse(lastMessage.data);

        if (msg.task === "respLoadCashRegisterConfig") {

            setClients(msg.data.clients || []);
            setZvtTerminals(msg.data.zvtTerminals || []);
        } else if (msg.task === "respSaveCashRegisterConfig") {
            if (msg.status === "SUCCEEDED") {
                setSaveStatus("success");
                setTimeout(() => setSaveStatus("idle"), 2000);
                sendMessage(JSON.stringify({ task: "loadCashRegisterConfig", station: cookies.station, staff: cookies.staff }));
            } else {
                setSaveStatus("error");
                setError(msg.error || "Unbekannter Fehler");
            }
        }
    }, [lastMessage, sendMessage]);

    const handleSave = useCallback((type, obj) => {
        setSaveStatus("saving");
        setError(null);
        sendMessage(JSON.stringify({ task: "saveCashRegisterConfig", station: cookies.station, staff: cookies.staff, data: { type, obj } }));
    }, [sendMessage]);

    const selectedClient = useMemo(() => {
        return selectedItem?.type === "station"
            ? clients.find(c => c.id === selectedItem.id)
            : null;
    }, [selectedItem, clients]);


    const selectedTerminal = useMemo(() => {
        return selectedItem?.type === "zvtTerminal"
            ? zvtTerminals.find(t => t.id === selectedItem.id)
            : null;
    }, [selectedItem, zvtTerminals]);

    const validateAssignments = (fiskalyId, zvtId, currentStation) => {
        const stationForFiskaly = clients.find(c => c.fiskalyClientId === fiskalyId && c.station !== currentStation);
        const stationForZvt = clients.find(c => c.zvtTerminalId === zvtId && c.station !== currentStation);

        if (stationForFiskaly) return `Fiskaly-Client ${fiskalyId} ist bereits zugewiesen zu ${stationForFiskaly.station}`;
        if (stationForZvt) return `ZVT-Terminal ${zvtId} ist bereits zugewiesen zu ${stationForZvt.station}`;
        return null;
    };

    const addNewStation = () => {
        const newId = "station-" + Math.floor(Math.random() * 10000);
        const newClient = { station: newId, fiskalyId: "", zvtTerminal: "" };
        setClients(prev => [...prev, newClient]);
        setSelectedItem({ type: "station", id: newId });
    };

    const addNewTerminal = () => {
        const newId = "zvt-" + Math.floor(Math.random() * 10000);
        const newTerminal = { id: newId, name: "Neues Terminal", ip: "", port: 20008 };
        setZvtTerminals(prev => [...prev, newTerminal]);
        setSelectedItem({ type: "zvtTerminal", id: newId });
    };


    useEffect(() => {
        const fetchClients = async () => {
            try {
                const res = await axios.get(`${KASSE_ENDPOINT}/clients`, authHeaders);

                const clients = res?.data?.clients?.data || [];
                setFiskalyClients(clients.map(e => ({ id: e._id, serial_number: e.serial_number })))

            } catch (err) {
                console.error("Fehler beim Laden der Clients:", err);
            }
        };

        fetchClients();
    }, []);


    return (
        <Box display="flex" height="100%">
            <Box
                width={280}
                borderRight="1px solid #ddd"
                p={2}
                sx={{ backgroundColor: "#f9f9f9" }}
            >
                <Typography variant="h6" gutterBottom>Stationen</Typography>

                <Stack spacing={1} mb={4}>
                    {clients.map(c => {
                        const isSelected = selectedItem?.id === c.id;
                        return (
                            <Button
                                key={c.id}
                                fullWidth
                                variant={isSelected ? "contained" : "text"}
                                onClick={() => setSelectedItem({ type: "station", id: c.id })}
                            >
                                {c.name || c.station}
                            </Button>
                        );
                    })}
                </Stack>


                <Typography variant="h6" gutterBottom>ZVT-Terminals</Typography>
                <Button
                    onClick={addNewTerminal}
                    fullWidth
                    size="small"
                    variant="outlined"
                    sx={{ mb: 2 }}
                >
                    + Neues Terminal
                </Button>

                <Stack spacing={1}>
                    {zvtTerminals.map(t => (
                        <Button
                            key={t.id}
                            fullWidth
                            variant={selectedItem?.id === t.id ? "contained" : "text"}
                            onClick={() => setSelectedItem({ type: "zvtTerminal", id: t.id })}
                        >
                            {t.name}
                        </Button>
                    ))}
                </Stack>
            </Box>

            <Box flex={1}>
                <Box sx={{ backgroundColor: "#f9f9f9", p: 2 }}>


                    {selectedItem?.type === "station" && selectedClient && (
                        <>
                            <Typography variant="h5" gutterBottom>
                                Station: {selectedClient.station}
                            </Typography>
                            <TextField
                                fullWidth
                                margin="normal"
                                select
                                label="Fiskaly Client"
                                value={selectedClient.fiskalyClientId}
                                onChange={(e) => {
                                    const validationError = validateAssignments(
                                        e.target.value,
                                        selectedClient.zvtTerminalId,
                                        selectedClient.station
                                    );
                                    if (validationError) return setError(validationError);
                                    setClients(prev =>
                                        prev.map(c =>
                                            c.id === selectedClient.id ? { ...c, fiskalyClientId: e.target.value } : c
                                        )
                                    );
                                }}
                            >
                                {fiskalyClients.map(fc => (
                                    <MenuItem key={fc.id} value={fc.id}>
                                        {fc.serial_number}
                                    </MenuItem>
                                ))}
                            </TextField>


                            <TextField
                                fullWidth
                                margin="normal"
                                select
                                label="ZVT Terminal"
                                value={selectedClient.zvtTerminalId}
                                onChange={(e) => {
                                    const validationError = validateAssignments(
                                        selectedClient.fiskalyClientId,
                                        e.target.value,
                                        selectedClient.station
                                    );
                                    if (validationError) return setError(validationError);
                                    setClients(prev =>
                                        prev.map(c =>
                                            c.id === selectedClient.id ? { ...c, zvtTerminalId: e.target.value } : c
                                        )
                                    );
                                }}
                            >
                                {zvtTerminals.map(zt => (
                                    <MenuItem key={zt.id} value={zt.id}>
                                        {zt.name} ({zt.id})
                                    </MenuItem>
                                ))}
                            </TextField>


                            <Button
                                variant="contained"
                                sx={{ mt: 2 }}
                                disabled={saveStatus === "saving"}
                                onClick={() => handleSave("client", selectedClient)}
                            >
                                Speichern
                            </Button>
                        </>
                    )}

                    {selectedItem?.type === "zvtTerminal" && selectedTerminal && (
                        <>
                            <Typography variant="h5" gutterBottom>
                                ZVT Terminal: {selectedTerminal.name}
                            </Typography>

                            <TextField
                                fullWidth
                                label="Name"
                                margin="normal"
                                value={selectedTerminal.name}
                                onChange={(e) =>
                                    setZvtTerminals(prev =>
                                        prev.map(t =>
                                            t.id === selectedTerminal.id ? { ...t, name: e.target.value } : t
                                        )
                                    )
                                }
                            />
                            <TextField
                                fullWidth
                                label="IP"
                                margin="normal"
                                value={selectedTerminal.ip}
                                onChange={(e) =>
                                    setZvtTerminals(prev =>
                                        prev.map(t =>
                                            t.id === selectedTerminal.id ? { ...t, ip: e.target.value } : t
                                        )
                                    )
                                }
                            />
                            <TextField
                                fullWidth
                                label="Port"
                                type="number"
                                margin="normal"
                                value={selectedTerminal.port}
                                onChange={(e) =>
                                    setZvtTerminals(prev =>
                                        prev.map(t =>
                                            t.id === selectedTerminal.id ? { ...t, port: parseInt(e.target.value, 10) } : t
                                        )
                                    )
                                }
                            />

                            <Button
                                variant="contained"
                                sx={{ mt: 2 }}
                                disabled={saveStatus === "saving"}
                                onClick={() => handleSave("zvtTerminal", selectedTerminal)}
                            >
                                Speichern
                            </Button>

                            <IngenicoZvtSetup />
                        </>
                    )}

                    {error && <Alert severity="error" sx={{ mt: 2 }}>{error}</Alert>}
                    {saveStatus === "success" && <Alert severity="success" sx={{ mt: 2 }}>Gespeichert!</Alert>}
                </Box>
            </Box>
        </Box>
    );
}




const StepTitle = ({ children }) => (
    <Typography variant="h6" sx={{ mt: 4, mb: 1 }}>
        {children}
    </Typography>
);

const IngenicoZvtSetup = () => {
    return (
        <Container maxWidth="md" sx={{ py: 4 }}>
            <Typography variant="h4" gutterBottom>
                Ingenico Move 5000 – ZVT Einrichtung (Step-by-Step)
            </Typography>

            <StepTitle>🛠 Voraussetzungen</StepTitle>
            <List>
                {["Service-/Technik-PIN", "Händler-PIN", "Kassierer-PIN", "WLAN-Name (SSID)", "WLAN-Passwort", "IP-Adresse des ZVT Terminal"].map((item, i) => (
                    <ListItem key={i}>
                        <ListItemText primary={item} />
                    </ListItem>
                ))}
            </List>

            <StepTitle>1. Zugang zum Funktionscode-Menü</StepTitle>
            <Typography>Drücke dreimal die <strong>[F]</strong>-Taste, bis die Codeeingabe erscheint.</Typography>

            <StepTitle>2. ZVT-Betriebsart aktivieren</StepTitle>
            <List>
                <ListItem><ListItemText primary="Gib '513' ein → Bestätigen" /></ListItem>
                <ListItem><ListItemText primary="Service-/Technik-PIN eingeben" /></ListItem>
                <ListItem><ListItemText primary="Betriebsart 'ZVT700' auswählen und bestätigen" /></ListItem>
                <ListItem><ListItemText primary="Warten: NW-Initialisierung → WiFi → Neustart" /></ListItem>
            </List>

            <StepTitle>3. Kassenschnittstelle konfigurieren</StepTitle>
            <List>
                <ListItem><ListItemText primary="Dreimal [F] drücken → Code '54' eingeben → Bestätigen" /></ListItem>
                <ListItem><ListItemText primary="Händler-PIN eingeben" /></ListItem>
                <ListItem><ListItemText primary="Zu 'Kasse' navigieren → 'TCP/IP' auswählen" /></ListItem>
                <ListItem><ListItemText primary="'Ethernet/WLAN' auswählen" /></ListItem>
                <ListItem><ListItemText primary="Host = IP-Adresse des ZVT Terminal" /></ListItem>
                <ListItem><ListItemText primary="Port = 20007" /></ListItem>
                <ListItem><ListItemText primary="Mit rotem X rausnavigieren → Neustart" /></ListItem>
            </List>

            <StepTitle>4. WLAN einrichten (DFÜ-Assistent)</StepTitle>
            <List>
                <ListItem><ListItemText primary="[F] → Einstellungen → Verbindungen → DFÜ-Assistent" /></ListItem>
                <ListItem><ListItemText primary="'WLAN' auswählen und eigenes Netzwerk wählen" /></ListItem>
                <ListItem><ListItemText primary="WLAN-Passwort eingeben" /></ListItem>
                <ListItem><ListItemText primary="DHCP = Ja auswählen → Bestätigen" /></ListItem>
            </List>

            <Divider sx={{ my: 4 }} />

            <Paper elevation={3} sx={{ p: 3, bgcolor: '#e0f7fa' }}>
                <Typography variant="h6">✅ Fertig!</Typography>
                <Typography>
                    Das Terminal zeigt jetzt "<strong>Kassenbetrieb bereit</strong>" oder "<strong>Betriebsbereit</strong>" an.
                    Die Kasse kann jetzt Zahlungen über ZVT starten.
                </Typography>
            </Paper>
        </Container>
    );
}